<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import {pad0, formatDate, getDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CalendarNavigation from "./CalendarNavigation.svelte";
    import CalendarDay from "./CalendarDay.svelte";
    import Alert from "../stores/alerts";
    import {TRANSFER_STATUS} from "../lib/constants";

    const weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const pageHeaderControls = [
        {id: 'today', name: 'THIS MONTH'},
    ];

    // let date = null;
    let calendar = [];
    let calendarDate = null;
    let calendarMonth = 0;
    let calendarYear = 0;
    let today = getDate();

    const getDaysInMonth = (month, year) => {
        return new Date(year, month, 0).getDate();
    };

    const stepMonth = (year, month, step) => {
        let m = month + step;
        let y = year;
        if (m > 12) {
            m = 1;
            y++;
        } else if (m < 1) {
            m = 12;
            y--;
        }

        return [y, m];
    }

    const setCalendar = () => {
        let monthDays = 0;
        let prevMonthDays = 0;
        calendar = [];

        monthDays = getDaysInMonth(calendarMonth, calendarYear);
        prevMonthDays = getDaysInMonth(calendarMonth - 1, calendarYear);
        let [previousYear, previousMonth] = stepMonth(calendarYear, calendarMonth, -1);
        let [nextYear, nextMonth] = stepMonth(calendarYear, calendarMonth, 1);

        let d = 0;
        let firstWeekDay = new Date(`${calendarYear}-${pad0(calendarMonth)}-01`).getDay() - 1; // 6 - Saturday
        if (firstWeekDay < 0) {
            firstWeekDay = 6;
        }
        // previous month
        d = prevMonthDays - firstWeekDay + 1;
        for (let index = 0; index < firstWeekDay; index++) {
            calendar.push({
                day: d,
                active: false,
                date: `${previousYear}-${pad0(previousMonth)}-${pad0(d)}`
            });
            d++;
        }
        // current month
        for (d = 1; d <= monthDays; d++) {
            calendar.push({
                day: d,
                active: true,
                date: `${calendarYear}-${pad0(calendarMonth)}-${pad0(d)}`
            });
        }
        // next month
        if (calendar.length % 7 > 0) {
            let daysToAdd = 7 - (calendar.length % 7);
            for (let d = 1; d <= daysToAdd; d++) {
                calendar.push({
                    day: d,
                    active: false,
                    date: `${nextYear}-${pad0(nextMonth)}-${pad0(d)}`
                });
            }
        }

        load();
    }

    const initialize = () => {
        let dt;
        // if (!date) {
        dt = new Date();

        // } else {
        //     dt = new Date(date);
        // }

        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();
        // calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;

        setCalendar();
    }

    const previousMonth = () => {
        calendarMonth--;
        if (calendarMonth < 1) {
            calendarYear--;
            calendarMonth = 12;
        }
        setCalendar();
    }

    const nextMonth = () => {
        calendarMonth++;
        if (calendarMonth > 12) {
            calendarYear++;
            calendarMonth = 1;
        }
        setCalendar();
    }

    const selectDate = (newDate) => {
        calendarDate = newDate;
        // date = newDate;
        router.go(`/app/calendar/${calendarDate}`)();
    }

    const load = () => {
        const onSuccess = result => {
            result.transfers.map(item => {
                // find date in calendar
                let cd = calendar.find(x => x.date === formatDate(item.transfer_at, 'y-m-d'));
                if (cd) {
                    if (item.status_id == TRANSFER_STATUS.OPEN) {
                        // add to date open transfers
                        if (!cd.total_open) cd.total_open = 0;
                        cd.total_open++;
                    }
                    // ad to arrivals, departures, transfers or tours
                    if (!cd.transfers) cd.transfers = [0, 0, 0, 0];
                    cd.transfers[item.route_type]++;
                }
            });
            calendar = calendar;
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading transfers.";
            Alert.warning("Transfers", message);
        };


        let data = {
            transfer_from: calendar[0].date,
            transfer_to: calendar[calendar.length - 1].date,
            // status_id: TRANSFER_STATUS.ASSIGNED
            status: [TRANSFER_STATUS.OPEN, TRANSFER_STATUS.ASSIGNED, TRANSFER_STATUS.CLOSED],
        }
        R.handle(R.transfer.monthTransfers, data, onSuccess, onFailure, LOADER.PAGE);
    }

    initialize();

    $: {
        today = getDate();
    }
</script>

<Route exact>
    <PageHeader title="Calendar" controls={ pageHeaderControls } on:today={ initialize }/>
    <CalendarNavigation title="{ months[calendarMonth - 1] } { calendarYear }"
                        on:click_previous="{ previousMonth }"
                        on:click_next="{ nextMonth }"/>

    <div class="calendar mb-4">
        {#each weekDays as wDay}
            <div class="weekday">
                { wDay }
            </div>
        {/each}
        {#each calendar as day}
            <div class="day" class:active={ day.active } class:selected="{ day.date === calendarDate }"
                 class:today={ day.date === today }
                 on:click="{ () => selectDate(day.date) }">
                {#if day.total_open}
                    <div class="has-open" title="{ day.total_open } open transfers">{ day.day }</div>
                {:else}
                    { day.day }
                {/if}
                {#if day.transfers}
                    <div class="day-transfers">
                        {#each day.transfers as item, index}
                            <div class="route type-{ index }" class:active={ item > 0 }>
                                {#if item > 0}
                                    { item }
                                {/if}
                            </div>
                        {/each}
                    </div>
                {/if}
            </div>
        {/each}
    </div>
</Route>
<Route match="*" let:router>
    <CalendarDay date="{ router.star }"/>
</Route>
<style>
    .calendar {
        color: #ababab;
        background: #fff;
        border: var(--default-border);
        border-radius: 3px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        text-align: center;
        grid-gap: 1px;
        background: var(--default-border-color);
    }

    .calendar .weekday {
        letter-spacing: 1px;
        line-height: 1;
        color: #803384;
        background: #e4eaee;
        padding: 15px 0;
    }

    .calendar .day {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        font-size: 1.05rem;
        font-weight: 500;
        background: #f8fafb;
        cursor: pointer;
    }

    .calendar .day:hover {
        background: #eeeeee;
    }

    .calendar .day.active {
        color: #333333;
        background: #fff;
    }

    .calendar .day.today {
        background: #fff1c6;
    }

    .calendar .day.selected {
        background: #e4eaee;
    }

    .calendar .day .has-open {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        line-height: 1;
        background: rgba(220, 53, 69, 0.22);
        border-radius: 50%;
    }

    .calendar .day .day-transfers {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
    }

    .calendar .day .day-transfers .route {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 30px;
        height: 25%;
        font-size: 0.8rem;
        font-weight: normal;
        line-height: 1;
        padding: 0 5px;
        opacity: 0.2;
        /*background: #eef5f9;*/
        /*border-bottom: 1px solid rgba(255, 255, 255, 0.5);*/
    }

    .calendar .day .day-transfers .route.active {
        opacity: 1;
    }

    .calendar .day .day-transfers .route.type-0 {
        color: var(--route-transfer-color);
        background: #e4eaee;
    }

    .calendar .day .day-transfers .route.type-1 {
        color: #fff;
        background: var(--route-arrival-color);
    }

    .calendar .day .day-transfers .route.type-2 {
        color: #fff;
        background: var(--route-departure-color);
    }

    .calendar .day .day-transfers .route.type-3 {
        color: #fff;
        background: var(--route-tour-color);
    }

    .calendar .day .open-transfers {
        background: #ccc;
        color: #e66465;
        position: absolute;
        top: 0;
        left: 0;
        width: 30px;
        font-size: 0.8rem;
        font-weight: normal;
        /* line-height: 1; */
        padding: 0 5px;
        opacity: 0.2;
    }

    @media (max-width: 576px) {
        .calendar .weekday {
            letter-spacing: unset;
        }

        .calendar .day {
            justify-content: flex-start;
            height: 60px;
            font-size: 1rem;
            font-weight: normal;
            padding: 0 0 0 8px;
        }

        .calendar .day .day-transfers .route {
            min-width: unset;
            font-size: 0.6rem;
            padding: 0 2px;
        }
    }
</style>